import { ErrorMessage } from "formik";
import { cn } from "../lib/utils";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import styles from "./CustomInput/custominput.module.css";

const CustomSelect = ({
  options,
  value,
  onChange,
  placeholder = "Select an option",
  className,
  contentClassName,
  error,
  disabled,
  required,
  name,
  onOpenChange,
  containerClassName,
  label,
  labelClassName,
  id,
  ...props
}) => {
  return (
    <div className={cn(styles.inputWrapper, containerClassName)}>
      {!!label && (
        <label htmlFor={id} className={cn(styles.title, labelClassName)}>
          {label}
        </label>
      )}
      <Select
        value={
          options &&
          options?.find((option) => String(option.value) === String(value))
            ?.value
        }
        onValueChange={onChange}
        disabled={disabled}
        name={name}
        required={required}
        onOpenChange={onOpenChange}
        {...props}
      >
        <SelectTrigger
          className={cn(
            "px-4 gap-3 py-10 rounded-md text-[15px] capitalize text-gray-500 focus:border-primary",
            error && "border-destructive !bg-[#FBFBFB] focus:ring-destructive",
            disabled ? "cursor-not-allowed opacity-50" : "",
            className
          )}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>

        <SelectContent
          className={cn("z-[9999] bg-white border p-2", contentClassName)}
        >
          {/* Reset option */}
          <SelectItem
            value={null}
            className={cn(
              "cursor-pointer capitalize",
              styles.title,
              disabled ? "cursor-not-allowed" : ""
            )}
            disabled
          >
            {placeholder}
          </SelectItem>
          {options && options?.map((option) => (
            <SelectItem
              key={option.value}
              value={String(option.value)}
              className={cn(
                "cursor-pointer capitalize",
                styles.title,
                disabled ? "cursor-not-allowed" : ""
              )}
            >
              {option?.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {!!name && (
        <ErrorMessage
          name={name}
          component="div"
          className="block mt-1 text-xs text-destructive"
        />
      )}
    </div>
  );
};

export default CustomSelect;
